import api from "@/lib/axios";

export const getTenants = async () => {
  const { data } = await api.get("/admin/tenants");
  return data.data;
};

export const createTenant = async (payload) => {
  const { data } = await api.post("/admin/tenants", payload);
  return data.data;
};

export const updateTenant = async (id, payload) => {
  const { data } = await api.patch(`/admin/tenants/${id}`, payload);
  return data.data;
};

export const createTenantUser = async (tenantId, payload) => {
  const { data } = await api.post(`/admin/tenants/${tenantId}/users`, payload);
  return data.data;
};

export const impersonateTenant = async (tenantId) => {
  const { data } = await api.post(`/admin/tenants/${tenantId}/impersonate`);
  return data.data; // { token, tenant }
};
